/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Why_WeightsInputs */

const en_landing_why_weights = /** @type {(inputs: Landing_Why_WeightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open weights`)
};

const zh_landing_why_weights = /** @type {(inputs: Landing_Why_WeightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开放权重`)
};

/**
* | output |
* | --- |
* | "Open weights" |
*
* @param {Landing_Why_WeightsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_why_weights = /** @type {((inputs?: Landing_Why_WeightsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Why_WeightsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_why_weights(inputs)
	return zh_landing_why_weights(inputs)
});
export { landing_why_weights as "landing.why.weights" }